export default __webpack_public_path__ + "media/faq/faq_awards_screenshot_2-9a49693a.png";